import { useContext } from "react"
import {
  TextureTestWizardContext,
  TextureTestWizardContextProvider,
  WizardSectionId
} from "./TextureTestWizardContextProvider"
import { WizardSection } from "./WizardSection"
import "./TextureTestWizard.scss"
import { TextureLevel, textureWizardDefinition } from "./WizardStepDefinitions"
import { WizardOutcome } from "./WizardOutcome"
import { WizardQuestion } from "./WizardQuestion"

export const TextureTestWizard = () => {
  return (
    <article className="TextureTestWizard">
      <TextureTestWizardContextProvider>
        <WizardCurrentPage />
      </TextureTestWizardContextProvider>
    </article>
  )
}

const WizardCurrentPage = () => {
  const { testTexture } = useContext(TextureTestWizardContext)
  const path = testTexture === undefined ? undefined : textureWizardDefinition.paths.get(testTexture)

  return (
    <>
      <WizStepSelectTestType />
      <WizStepSelectFoodTextureLevel />
      <WizStepSelectFluidThicknessLevel />

      {path && path.map((s, i) => <WizardQuestion key={`step-${i}`} level={testTexture!} step={s} stepIndex={i} />)}

      <WizardOutcome />

      <div className="bottom-panel">
        <a className="built-by" href="https://www.embrayse.com/?src=iddsi-tool">
          <div>
            Built by{" "}
            <img
              className="logo"
              src="https://embrayseprdpublicstorage.blob.core.windows.net/iddsi-tool/static/media/logo.png"
              alt="Embrayse"
            />
          </div>
          <div>Smart catering software for aged care</div>
        </a>
      </div>
    </>
  )
}

export const WizStepSelectTestType = () => {
  const { section, goToSection } = useContext(TextureTestWizardContext)

  return (
    <WizardSection visible={section === WizardSectionId.SelectTestType}>
      <header>
        <h1>
          Use this tool to test food and drink textures for adults with dysphagia, according to the{" "}
          <a href="https://iddsi.org/" target="_blank" rel="noreferrer">
            IDDSI Framework
          </a>
        </h1>
      </header>
      <br />
      <p>What do you want to test?</p>
      <button
        id="btn-iddsi-food-texture"
        className="wide"
        onClick={() => goToSection(WizardSectionId.SelectFoodTextureLevel)}>
        Food Texture
      </button>
      <button
        id="btn-iddsi-fluid-thickness"
        className="wide"
        onClick={() => goToSection(WizardSectionId.SelectFluidThicknessLevel)}>
        Fluid Thickness
      </button>
    </WizardSection>
  )
}

export const WizStepSelectFoodTextureLevel = () => {
  const { section, goToSection, setTestTexture, getTextureLabel } = useContext(TextureTestWizardContext)

  const handleLevelSelect = (testTexture: TextureLevel) => {
    setTestTexture(testTexture)
    goToSection(WizardSectionId.Questionnaire)
  }

  return (
    <WizardSection visible={section === WizardSectionId.SelectFoodTextureLevel}>
      <p>What level do you want to test?</p>
      <button id="btn-iddsi-LQ3" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.LQ3)}>
        {getTextureLabel(TextureLevel.LQ3)}
      </button>
      <button id="btn-iddsi-PU4" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.PU4)}>
        {getTextureLabel(TextureLevel.PU4)}
      </button>
      <button id="btn-iddsi-MM5" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.MM5)}>
        {getTextureLabel(TextureLevel.MM5)}
      </button>
      <button id="btn-iddsi-SB6" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.SB6)}>
        {getTextureLabel(TextureLevel.SB6)}
      </button>
      <button id="btn-iddsi-EC7" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.EC7)}>
        {getTextureLabel(TextureLevel.EC7)}
      </button>
    </WizardSection>
  )
}

export const WizStepSelectFluidThicknessLevel = () => {
  const { section, goToSection, setTestTexture, getTextureLabel } = useContext(TextureTestWizardContext)

  const handleLevelSelect = (testTexture: TextureLevel) => {
    setTestTexture(testTexture)
    goToSection(WizardSectionId.Questionnaire)
  }

  return (
    <WizardSection visible={section === WizardSectionId.SelectFluidThicknessLevel}>
      <p>What level do you want to test?</p>
      <button id="btn-iddsi-ST1" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.ST1)}>
        {getTextureLabel(TextureLevel.ST1)}
      </button>
      <button id="btn-iddsi-MT2" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.MT2)}>
        {getTextureLabel(TextureLevel.MT2)}
      </button>
      <button id="btn-iddsi-MO3" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.MO3)}>
        {getTextureLabel(TextureLevel.MO3)}
      </button>
      <button id="btn-iddsi-EX4" className="extra-wide" onClick={() => handleLevelSelect(TextureLevel.EX4)}>
        {getTextureLabel(TextureLevel.EX4)}
      </button>
    </WizardSection>
  )
}
